import { FC } from 'react'

import { AttributeSection } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../app/_providers/TranslationProvider.client'
import { EmbroiderySectionTitle } from '../EmbroiderySectionTitle'
import { EmbroiderySectionWrapper } from '../EmbroiderySectionWrapper'

import { EmbroideryCta } from './EmbroideryCta'

interface Props {
  isInvalid?: boolean
  isRequired?: boolean
}

/**
 * Display a standalone label & CTA for text embroidery.
 **/
export const TextEmbroiderySection: FC<Props> = ({ isInvalid, isRequired }) => {
  const { embroidery: strings } = useTranslation()

  const sectionTitle = (
    <EmbroiderySectionTitle
      isInvalid={isInvalid}
      errorMessage={strings.validation.required}
      isRequired={isRequired}
    >
      {strings.textTitle}
    </EmbroiderySectionTitle>
  )

  return (
    <EmbroiderySectionWrapper className='personalize-section'>
      <AttributeSection title={sectionTitle} isInvalid={isInvalid}>
        <EmbroideryCta />
      </AttributeSection>
    </EmbroiderySectionWrapper>
  )
}
